export let selectpicker = () => {
	// Selectpicker
	$(`select.slctpckr`).each((_index, element) => {
		// Enable default selected value by passing the data-value in the select
		let $element = $(element);
		let value = $element.attr('data-value');
		$element.selectpicker({
			dropupAuto: false,
			size: 5
		});

		if(!_.isNil(value)) {
			$element.selectpicker('val', value);
			$element.selectpicker('refresh');
		}

		// Update value attr
		$element.on('changed.bs.select', () => {
			$element.attr('data-value', $element.selectpicker().val());
		});

		$element.on('refreshed.bs.select', () => {
			value = $element.attr('data-value');

			if(!_.isNil(value)) {
				$element.selectpicker('val', value);
			}
		});

		$element.on('shown.bs.select', () => {
			// not needed on the dashboard (it has an overlay and this causes double sidebars)
			if($element.closest('.personalisedDashboardWidget').length > 0) return;			
		});
	});
};
